import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-search-filters-modal',
  template: `
    <fl-text i18n="Webapp component test string">
      search-filters-modal works!
    </fl-text>

    <app-search-filters-users
      *ngIf="for === 'users'"
    ></app-search-filters-users>

    <app-search-filters-projects
      *ngIf="for === 'projects'"
    ></app-search-filters-projects>

    <app-search-filters-contests
      *ngIf="for === 'contests'"
    ></app-search-filters-contests>
  `,
})
export class SearchFiltersModalComponent {
  @Input() for: string;
}
